<template>
  <div class="hidden flex-col gap-[28px] xl:flex">
    <div>
      <div class="mb-[28px] rounded-[12px] px-[24px] py-[28px] shadow-drop-2">
        <CommonTableOfContents
          class="mb-[24px] border-b border-[#D9D9D9] pb-[24px]"
        />
        <CommonSocialsSocialSharing state="horizontal" />
      </div>
      <div class="flex flex-col">
        <h4 class="mb-[20px] text-[20px] font-medium">Новое</h4>

        <div class="flex flex-col">
          <MainPageCardsReworkedBaseCard
            v-for="(article, index) in articles?.data?.value?.data"
            :key="index"
            disable-preview
            :data="article"
          />
        </div>
      </div>
      <div
        v-if="filmsMaterials?.data?.value?.length"
        class="mt-7 flex flex-col"
      >
        <h4 class="mb-[20px] text-[20px] font-medium">Видео</h4>
        <div class="flex flex-col">
          <MainPageCardsReworkedVideoCard
            v-for="(v, index) in filmsMaterials?.data?.value"
            :key="index"
            :data="v"
            disable-preview
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  articlesPerPage: {
    type: String,
    default: '6',
  },
  videoPerPage: {
    type: String,
    default: '3',
  },
});

const { articles } = useArticles({ per_page: props.articlesPerPage });

const { filmsMaterials } = useFilmsMaterials(props.videoPerPage);
</script>
